import axios from "axios";


const state = {
  user: null,
  balance: '',
  commissionBalance:"",
  authUser: null,
  loading: false,
  serverMessage:'',
  snackbar:false,
  step:1,
  customerID:""
};

const getters = {
  getUser(state) {
    return state.user;
  },
  getcustomerID(state){
    return state.customerID;
  },
  getSignUpStep(state) {
    return state.step;
  },
  getBalance(state) {
    return state.balance;
  },
  getCommissionBalance(state) {
    return state.commissionBalance;
  },
  getLoading(state){
    return state.loading
  },
  getauthUser(state){
    return state.authUser
  },
  getServerMessage(state){
    return state.serverMessage
  }
};

const mutations = {

  setUser(state, payload) {
    state.user = payload;
  },

  setAuthUser(state, payload) {
    state.authUser = payload;
  },

  setSignUpStep(state, payload) {
    state.step = payload;
  },

  setBalance(state, payload) {
    state.balance = payload;
  },
  setCommissionBalance(state, payload) {
    state.commissionBalance = payload;
  },

  setLoading(state, payload){
    state.loading = payload
  },

  setServerMessage(state, payload){
    state.serverMessage = payload
  },
  setSnackbar(state, payload){
    state.snackbar = payload
  },
  setcustomerID(state,payload){
    state.customerID=payload
  }

};

const actions = {
  
  LoginFuc({commit}, payload) {
    commit("setLoading", true);
    commit("setSnackbar", false); 
   let redirect = payload.redirect;
    axios
      .post(`https://backoffice.teller.ng/TellerAppManager/api/LoginRequest?customerID=${payload.walletId}&pin=${payload.pin}&location='WEBSITE'&imei='WEBSITE'`,{},{timeout:20000})
      .then(res => {
        if(res.data.message == 'OK'){
          let data ={
            ...res.data,
            pin:payload.pin
          }
          commit("setUser",  data );
          commit("setBalance",  res.data.mainBalance );
          commit("setCommissionBalance",  res.data.commissionBalance );
          console.log(res.data)
          if (redirect) {
            payload.route.push({path:redirect});
          } else {
          payload.route.push({name: "dashboard"})
          }
        }else{
          commit("setSnackbar", true);
          commit("setServerMessage", res.data.message)
        } 
      })
      .catch(err => {
        console.log(err, 'err')
        if (err.code === 'ECONNABORTED'){
          commit("setSnackbar", true);
          commit("setServerMessage",  "Server Timeout" );
          return
        }
        commit("setServerMessage",  err.message );
      })
      .finally(()=>{
        commit("setLoading", false);
      })
  },

  RegistrationRequestFuc({commit}, payload) {
    commit("setLoading", true);
    commit("setSnackbar", false);
    axios
      .post(`https://backoffice.teller.ng/TellerAppManager/api/RegistrationRequest?firstname=${payload.firstname}&lastname=${payload.lastname}&middlename=${payload.middlename}&mobileNumber=${payload.mobileNumber}&location='WEBSITE'&pin=${payload.pin}&email=${payload.email}&stateCode=${payload.statecode}`,{},{timeout:20000})
      .then(res => {
        console.log(res.data)
        if(res.data.message == 'OK'){
          commit("setSignUpStep", 4);
          commit("setcustomerID", res.data.customerID)
         
        }else{
          commit("setSnackbar", true);
          commit("setServerMessage", res.data.message)
        } 
      })
      .catch(err => {
        console.log(err, 'err')
        if (err.code === 'ECONNABORTED'){
          commit("setSnackbar", true);
          commit("setServerMessage",  "Server Timeout" );
          return
        }
        commit("setServerMessage",  err.message );
      })
      .finally(()=>{
        commit("setLoading", false);
      })
  },

  SnackbarFunc({commit}, payload){
  commit("setSnackbar", payload.status);
  commit('setServerMessage', payload.message)
  setTimeout(() =>{console.log("P");  commit("setSnackbar", false);}, 5000);
  },

  SendVerificationCode({commit}, payload) {
    commit("setLoading", true);
    commit("setSnackbar", false);
    console.log(payload)
    axios
      .post(`https://backoffice.teller.ng/TellerAppManager/api/AccountVerificationRequest?customerID=${payload.customerID}&code=${payload.otpCode}`,{},{timeout:20000})
      .then(res => {
        console.log(res.data)
        if(res.data.message == 'OK'){
          commit("setSignUpStep", 5);      
        }else{
          commit("setSnackbar", true);
          commit("setServerMessage", res.data.message)
        } 
      })
      .catch(err => {
        console.log(err, 'err')
        if (err.code === 'ECONNABORTED'){
          commit("setSnackbar", true);
          commit("setServerMessage",  "Server Timeout" );
          return
        }
        commit("setServerMessage",  err.message );
      })
      .finally(()=>{
        commit("setLoading", false);
      })
  },
  
  resendOtp({commit}, payload) {
    commit("setLoading", true);
    commit("setSnackbar", false);
    console.log(payload)
    axios
      .post(`https://backoffice.teller.ng/TellerAppManager/api/ResendVerificationCode?customerID=${payload.customerID}`,{},{timeout:20000})
      .then(res => {
        console.log(res.data)
        if(res.data.message == 'OK'){
          commit("setSignUpStep", 4);
          commit("setcustomerID", res.data.customerID)    
        }else{
          commit("setSnackbar", true);
          commit("setServerMessage", res.data.message)
        } 
      })
      .catch(err => {
        console.log(err, 'err')
        if (err.code === 'ECONNABORTED'){
          commit("setSnackbar", true);
          commit("setServerMessage",  "Server Timeout" );
          return
        }
        commit("setServerMessage",  err.message );
      })
      .finally(()=>{
        commit("setLoading", false);
      })
  },


};

export default {
  state,
  mutations,
  getters,
  actions
};
